<div class="container">
  <div class="content-card" fxFlex="100">
    <div class="parent" fxFlex="100">
      <div class="row">
        <img src="/assets/images/check.png" alt="" />
      </div>
      <h2>{{ 'Annex.SuccessfullySigned' | translate }}</h2>
      <div class="row top-margin">
        <h3>{{ 'Annex.SignatureConfirmation' | translate }}</h3>
      </div>
      <div class="row">
        <h3>{{ 'Annex.AfterSigningStatusChanged' | translate }}</h3>
      </div>

      @if (pendingAnnexes.length > 0) {
        <div class="pending-annexes-section">
          <h3>{{ 'Annex.OtherAnnexesPendingSigning' | translate }}</h3>
          <ul class="pending-annexes-list">
            @for (annex of pendingAnnexes; track annex.AnnexId) {
              <li>
                <a
                  [routerLink]="[
                    '/workers',
                    annex.WorkerId,
                    'employmentType',
                    annex.EmploymentTypeId,
                    'agreements',
                    annex.WorkerAgreementId,
                    'annexes',
                    annex.AnnexId,
                    'signature',
                  ]"
                >
                  {{ 'Annex.AnnexFromDate' | translate }} {{ annex.ConclusionDate | date: 'dd.MM.yyyy' }} {{ 'Annex.EffectiveFrom' | translate }}
                  {{ annex.StartDate | date: 'dd.MM.yyyy' }}
                </a>
              </li>
            }
          </ul>
        </div>
      }

      <div class="row top-margin">
        <a mat-raised-button color="primary" class="button" [routerLink]="['/profile', workerId, 'agreements']">
          {{ 'SAA-ShowAgreementsOnWorkerProfile' | translate }}
          <mat-icon>arrow_forward</mat-icon>
        </a>
      </div>
    </div>
  </div>
</div>
